// extracted by mini-css-extract-plugin
export default {"table":"table--a8Vfx","row":"row--yWiYu"};